export function IconDownload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      {...props}
    >
      <path
        d="M17 8.18054L16.9974 15.1805L1 15.1805L1 8.18054"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path d="M6.27818 8.48289L8.9192 11.1239" stroke="currentColor" strokeLinecap="round" />
      <path d="M11.5598 8.48289L8.9188 11.1239" stroke="currentColor" strokeLinecap="round" />
      <path d="M8.9192 1.44015L8.9192 11.1239" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
}
